// React
import React from 'react';
// External
import { Link, withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ButtonImage from 'components/shared/molecules/ButtonImage/ButtonImage';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import CustomTable from 'components/shared/molecules/CustomTable/CustomTable';
import { getBookings } from 'services/booking';
import newBooking from 'models/Booking';
import VetService from 'services/vet';
import BookingImage from 'components/shared/atoms/BookingImage/BookingImage';
import imageFallback from 'assets/images/image-not-available.png';
import Pagination from 'components/shared/molecules/Pagination/PaginationAwaiting';
import PaginationReturn from 'components/shared/molecules/PaginationReturn/PaginationReturn';
import ContainerHeader from 'components/shared/molecules/ContainerHeader/ContainerHeader';
import {
    updateBooking,
    clearBooking
} from 'stores/actions';
// Images
import pawHash from 'assets/icons/paw-hash.svg';
import listHash from 'assets/icons/list-hash.svg';
import vetSupplyOrder from 'assets/icons/vet-supply-order.svg';
// Style
import './styles.scss';
import { FaCheckCircle } from 'react-icons/fa';
import EDIT_BOOKING_PATH from 'constants/editBookingPath';
import { logErrorToAtatus } from 'services/atatus';

const VET_SUPPLY_ORDER = 'vet supply order'

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        const page = new URLSearchParams(window.location.search).get('page');
        const table = new URLSearchParams(window.location.search).get('table');
        this.state = {
            bookingsAwaitInst: [],
            bookingsAwaitRet: [],
            hasVetSupplyOrder: false,
            viewPartialBookings: localStorage.getItem('viewPartialBookings') ? localStorage.getItem('viewPartialBookings') == '1' ? true : false : false,
            objLightBox: {},
            lastPageAwaitInstruct: null,
            lastPageAwaitReturn: null,
            currentPageAwaitInstruct: null,
            currentPageAwaitReturn: null,
            currentPage: page,
            table: table,
            isReturn: table==='return' ? true : false
        };
        this.props.clearBooking();
        this.headersAwaitInst = Object.freeze([
            {
                name: 'Booking ID',
                id: 'orderId',
                className: 'order-id',
            },
            {
                name: 'Pet Tag',
                id: 'img',
                className: 'pet-tag'
            },
            {
                name: 'Service Type',
                id: 'type',
            },
            {
                name: 'Date Created',
                id: 'dateEntered',
                className: 'date-created',
            },
            {
                name: 'Owner Name',
                id: 'ownerName',
            },
            {
                name: 'Pet Name',
                id: 'petName',
            },
            {
                name: 'Status',
                id: 'orderStage',
            },
            {
                name: 'Action',
                id: 'action',
            },
        ]);

        this.headersAwaitRet = Object.freeze([
            {
                name: 'Booking ID',
                id: 'orderId',
                className: 'order-id',
            },
            {
                name: 'Pet Tag',
                id: 'img',
                className: 'pet-tag'
            },
            {
                name: 'Service Type',
                id: 'type',
            },
            {
                name: 'Date Created',
                id: 'dateEntered',
                className: 'date-created',
            },
            {
                name: 'Owner Name',
                id: 'ownerName',
            },
            {
                name: 'Pet Name',
                id: 'petName',
            },
            {
                name: 'Status',
                id: 'orderStage',
            },
            {
                name: 'Action',
                id: 'action',
            },
        ]);
        this.getServiceTypes();
    }

    componentDidMount() {
        if(isEmpty(this.state.table)) {
            localStorage.removeItem('currentPageAwaitInstruct')
            localStorage.removeItem('currentPageAwaitReturn')
            this.setState({ currentPage: 1 });
        }
        this.getVetDetails();
        localStorage.removeItem('vet-supply-id')
        // Remove service type name
        localStorage.removeItem('service-type-name')
    }

    viewPartialBookings = () => {
        const page = new URLSearchParams(window.location.search).get('page');
        if(page !== '1') {
            window.location.href = window.location.origin + this.props.location.pathname +'?page=1&table=instruction'
        }
        this.setState(prevState => ({
            viewPartialBookings: !prevState.viewPartialBookings
        }), () => {
            // store to local storage to retain filter on page refresh
            localStorage.setItem('viewPartialBookings', this.state.viewPartialBookings ? '1' : '0');
            // Load data based on filter
            if (this.state.viewPartialBookings) {
                this.getBookingsAwaitInst(['VP Unsubmitted', 'Pet Collected - Pending Details'])
            } else {
                this.getBookingsAwaitInst(['Pet Collected - Pending Details']);
            }
        })
    }

    /**
     * Retrieves the service types to display in the booking type selection
     */
     getServiceTypes = () => {
        VetService.getServiceTypes()
            .then((response) => {
                const responseData = response.data;
                let responseDataArr = [];
                if (!Array.isArray(responseData)) {
                    const keys = Object.keys(responseData);
                    keys.forEach((key) => {
                        responseDataArr.push(responseData[key]);
                    });
                } else {
                    responseDataArr = responseData;
                }

                if (responseDataArr) {
                    let isFound = responseDataArr.some((serviceType) => serviceType?.name?.toLowerCase() ===  VET_SUPPLY_ORDER?.toLowerCase());
                    this.setState({hasVetSupplyOrder: isFound}) // FPC-1251 - vet supply option hidden for now
                }
            }).catch((err) => {
                console.error(err);
            });
    }

    /**
     * Get vet details and then get table data
     */
     getVetDetails() {
        VetService.getVetDetails()
            .then((response) => {
                this.setState({ vet: response.data }, () => {
                    this.getBookingsAwaitRet();
                    // Load data based on filter
                    if (this.state.viewPartialBookings) {
                        this.getBookingsAwaitInst(['VP Unsubmitted', 'Pet Collected - Pending Details'])
                    } else {
                        this.getBookingsAwaitInst(['Pet Collected - Pending Details']);
                    }
                });
            }).catch((err) => {
                console.error(err);
            });
    }
    scrollElement () {
         // Store a 'this' ref, and
            const table = new URLSearchParams(window.location.search).get('table');
            const element = document.getElementById(table);
            if (element) {
                // 👇 Will scroll smoothly to the top of the next section
                element.scrollIntoView({ behavior: 'smooth' });
            }
    }
    getBookingByStageInstruction = async (stage) => {
        try {
            const bookingData = {
                booking_status: 'Close',
                order_stage: stage,
                page: this.state.table === 'instruction' ? this.state.currentPage : localStorage.getItem('currentPageAwaitInstruct'),
                page_size: 5,
                booking_type: 'Private',
                relationship_type: this.state.vet?.cstm?.relationship_type_c ?? '',
                origin: stage,
            };
            const response = await getBookings(bookingData);
            this.setState({ lastPageAwaitInstruct: response.data.last_page });
            if(this.state.lastPageAwaitReturn !== null) {
                setTimeout(() => {
                    this.scrollElement()
                 }, 500);
            }
            localStorage.setItem('currentPageAwaitInstruct',response.data.current_page)
            localStorage.setItem('currentTableInstruct','instruction')
            return response.data.data.map((booking) => newBooking(booking));
        } catch (err) {
            logErrorToAtatus('Failed to get bookings', err)
            return [];
        }
    }

    getBookingByStageReturn = async (stage) => {
        try {
            const bookingData = {
                booking_status: 'Close',
                order_stage: stage,
                page: this.state.table === 'return' ? this.state.currentPage : localStorage.getItem('currentPageAwaitReturn'),
                page_size: 5,
                booking_type: 'Private',
                relationship_type: this.state.vet?.cstm?.relationship_type_c ?? '',
                origin: stage,
            };
            const response = await getBookings(bookingData);
            this.setState({ lastPageAwaitReturn: response.data.last_page });
            if(this.state.lastPageAwaitInstruct !== null) {
                setTimeout(() => {
                    this.scrollElement()
                 }, 500);
            }
            localStorage.setItem('currentPageAwaitReturn',response.data.current_page)
            localStorage.setItem('currentTableReturn','return')
            return response.data.data.map((booking) => newBooking(booking));
        } catch (err) {
            return [];
        }
    }

    async getBookingsAwaitInst(order_stage) {
        const bookingList = await this.getBookingByStageInstruction(order_stage);
        const bookingsAwaitInst = bookingList.map((booking) => {
            let bookingImage = booking.getImage();
            let withCremationPackage = false;
            // check if booking has a package
            const productsWithCremationPackage = booking.quotedProducts.find((product) => {
                if (product.name.toLowerCase().includes('cremation package')) {
                    return product;
                }
            });
            if (productsWithCremationPackage) {
                withCremationPackage = true;
            }
            // get path
            let editBookingPath = EDIT_BOOKING_PATH.find((editBookingPath) => {
                // if package
                if (withCremationPackage || booking.isPackage) {
                    if (editBookingPath.path === "package") {
                        return editBookingPath;
                    }
                } else if (booking.opportunityType === "referral" &&
                    (booking.serviceType.name === "Private Cremation & Return of Ashes" ||
                     booking.serviceType.name === "Private Cremation & Dispersal of Ashes"
                    )
                ) { // if private cremation & return of ashes referral
                    if (editBookingPath.path === "referral") {
                        return editBookingPath;
                    }
                } else if (editBookingPath.serviceType === booking.serviceType.name) {
                    return editBookingPath.path;
                }
            });
            return {
                img: <BookingImage bookingImage={bookingImage} onClick={(evt, imageUrl) => {
                    // Only change the lightbox state for non-fallback images
                    if (evt.target.src !== window.location.origin + imageFallback) {
                        this.setState({
                            objLightBox: {
                                index: booking.orderId,
                                url: imageUrl,
                                onClose: (e) => {
                                    this.setState({ objLightBox: {} }, () => document.body.style.overflow = 'unset');
                                }
                            },
                        }, () => document.body.style.overflow = 'hidden');
                    }
                }} />,
                ...booking.customTableFormat(),
                action: (<>
                            { booking.isEditable() && editBookingPath?.path && booking.parsedOrderStage === "Unsubmitted" ?
                                <Link
                                    to={`/edit-booking-${editBookingPath.path}/${booking.id}`}
                                    onClick={() => localStorage.setItem('service-type-name', booking?.serviceType?.name)}
                                >Edit</Link> : null
                            }
                            <Link to={`/booking/${booking.id}`}>View</Link>
                        </>)
            };
        });
        this.setState({ bookingsAwaitInst });
    }

    async getBookingsAwaitRet() {
        const bookingList = await this.getBookingByStageReturn(['Awaiting Return Delivery']);
        const bookingsAwaitRet = bookingList.map((booking) => {
            let bookingImage = booking.getImage();
            let withCremationPackage = false;
            // check if booking has a package
            const productsWithCremationPackage = booking.quotedProducts.find((product) => {
                if (product.name.toLowerCase().includes('cremation package')) {
                    return product;
                }
            });
            if (productsWithCremationPackage) {
                withCremationPackage = true;
            }
            // get path
            let editBookingPath = EDIT_BOOKING_PATH.find((editBookingPath) => {
                // if package
                if (withCremationPackage || booking.isPackage) {
                    if (editBookingPath.path === "package") {
                        return editBookingPath;
                    }
                } else if (booking.opportunityType === "referral" &&
                    (booking.serviceType.name === "Private Cremation & Return of Ashes" ||
                     booking.serviceType.name === "Private Cremation & Dispersal of Ashes"
                    )
                ) { // if private cremation & return of ashes referral
                    if (editBookingPath.path === "referral") {
                        return editBookingPath;
                    }
                } else if (editBookingPath.serviceType === booking.serviceType.name) {
                    return editBookingPath.path;
                }
            });
            return {
                img: <BookingImage bookingImage={bookingImage} onClick={(evt, imageUrl) => {
                    // Only change the lightbox state for non-fallback images
                    if (evt.target.src !== window.location.origin + imageFallback) {
                        this.setState({
                            objLightBox: {
                                index: booking.orderId,
                                url: imageUrl,
                                onClose: (e) => {
                                    this.setState({ objLightBox: {} }, () => document.body.style.overflow = 'unset');
                                }
                            },
                        }, () => document.body.style.overflow = 'hidden');
                    }
                }} />,
                ...booking.customTableFormat(),
                action: (<>
                        { booking.isEditable() && editBookingPath?.path && booking.parsedOrderStage === "Unsubmitted"?
                            <Link
                                to={`/edit-booking-${editBookingPath.path}/${booking.id}`}
                                onClick={() => localStorage.setItem('service-type-name', booking?.serviceType?.name)}
                            >Edit</Link> : null
                        }
                        <Link to={`/booking/${booking.id}`}>View</Link>
                    </>)
            };
        });
        this.setState({ bookingsAwaitRet });
    }

    render() {
        return (
            <div className="main-container">
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    <PageTitle title="Dashboard" />
                    <Container className="m-auto w-fit">
                        <ButtonImage
                            to="/new-booking"
                            buttonStyle={{ height: 180, width: 280 }}
                            imageStyle={{ paddingTop: '5px' }}
                            imageHeight="64"
                            imageWidth="64"
                            src={pawHash}
                            alt="Paw with hash icon"
                            title="New Booking"
                            titleStyle={{ marginBottom: '30px', width: '100%' }}
                        />
                        {
                            this.state.hasVetSupplyOrder ?
                            <ButtonImage
                                to={`/new-booking?bookingoption=${VET_SUPPLY_ORDER}`}
                                buttonStyle={{ height: 180, width: 280 }}
                                imageStyle={{ paddingTop: '5px' }}
                                imageHeight="64"
                                imageWidth="64"
                                src={vetSupplyOrder}
                                alt="Vet supply order icon"
                                title="Vet Supply Order"
                                titleStyle={{ marginBottom: '30px', width: '100%' }}
                            /> : ''

                        }
                        <ButtonImage
                            to="/bookings"
                            buttonStyle={{ height: 180, width: 280 }}
                            imageStyle={{ paddingTop: '5px' }}
                            imageHeight="64"
                            imageWidth="64"
                            src={listHash}
                            alt="List icon"
                            title="View All Bookings"
                            titleStyle={{ marginBottom: '30px', width: '100%' }}
                        />
                    </Container>
                    <div id='instruction'>
                        <ContentCard
                            className="mt-62"
                            divider={false}
                        >
                                    <ContainerHeader
                                        title="Private Cremation: Awaiting Instructions"
                                        btnText="View all bookings"
                                        style={{ marginBottom: '30px' }}
                                        to="/bookings"
                                    />
                            <div className="w-100" style={{display: 'inline-block'}}>
                                <Button
                                className="viewPartialBookingsButton"
                                variant={this.state.viewPartialBookings ? "outline-primary": "outline-dark"}
                                style={{ float: 'left', marginLeft: '25px', marginBottom: this.state.bookingsAwaitInst.length > 0 ? '20px' : ''}}
                                onClick={this.viewPartialBookings}
                                active={this.state.viewPartialBookings && true}
                                >
                                    {'View partial bookings '}
                                    {this.state.viewPartialBookings && <FaCheckCircle size="15"/>}
                                </Button>
                            </div>
                            {
                                this.state.bookingsAwaitInst.length > 0
                                    ? <CustomTable
                                            data={this.state.bookingsAwaitInst}
                                            headers={this.headersAwaitInst}
                                            className="dashboard-table"
                                            disableSort={ true }
                                            lightBox={this.state.objLightBox}
                                            defaultSortBy={
                                                {
                                                    id: 'dateEntered',
                                                    desc: true,
                                                }
                                            }
                                        />
                                    : (
                                        <p className="empty-table-text">No bookings found</p>
                                    )
                            }
                            <Pagination className="booking-paginator" lastPage={this.state.lastPageAwaitInstruct} table='instruction'/>
                        </ContentCard>
                    </div>
                   <div id='return'>
                    {
                            this.state.vet?.cstm?.relationship_type_c && this.state.vet.cstm.relationship_type_c === 'vet_direct' ?
                                <ContentCard
                                    className="mt-40"
                                    divider={false}
                                >
                                    <ContainerHeader
                                        title="Private Cremation: Awaiting Return"
                                        btnText="View all bookings"
                                        style={{ marginBottom: '30px' }}
                                        to="/bookings"
                                    />
                                    {
                                        this.state.bookingsAwaitRet.length > 0
                                            ? <div id='return'>
                                                <CustomTable
                                                    data={this.state.bookingsAwaitRet}
                                                    headers={this.headersAwaitRet}
                                                    className="dashboard-table"
                                                    disableSort={ true }
                                                    lightBox={this.state.objLightBox}
                                                    defaultSortBy={
                                                        {
                                                            id: 'dateEntered',
                                                            desc: true,
                                                        }
                                                    }
                                                />
                                            </div> : <p className="empty-table-text">No bookings found</p>
                                    }
                                    <PaginationReturn className="booking-paginator" lastPage={this.state.lastPageAwaitReturn} table='return' />
                                </ContentCard> : null
                        }
                   </div>

                    </div>
            </div>
        );
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        clearBooking: () => dispatch(clearBooking())
    };
};
export default connect(null, mapDispatchToProps)(withRouter(Dashboard));
